import { createSlice } from '@reduxjs/toolkit';

import {
    ADD_SEGMENT_MODAL_OPEN_STATUS,
    DELETE_SEGMENT,
    DELETE_SEGMENT_FAILURE,
    DELETE_SEGMENT_SUCCESS,
    EDIT_SEGMENT,
    EDIT_SEGMENT_FAILURE,
    EDIT_SEGMENT_SUCCESS,
    ENABLED_EDITION,
    ENABLED_EDITION_FAILURE,
    ENABLED_EDITION_SUCCESS,
    FETCH_OFFER_INFO_PATERN,
    FETCH_OFFER_INFO_PATERN_FAILURE,
    FETCH_OFFER_INFO_PATERN_SUCCESS,
    FETCH_OFFER_PANELS,
    FETCH_OFFER_PANELS_FAILURE,
    FETCH_OFFER_PANELS_SUCCESS,
    FETCH_PARENT_FIELD_SEGMENT,
    FETCH_PARENT_FIELD_SEGMENT_FAILURE,
    FETCH_PARENT_FIELD_SEGMENT_SUCCESS,
    GENERATE_PROPOSAL,
    GENERATE_PROPOSAL_FAILURE,
    GENERATE_PROPOSAL_SUCCESS,
    INITIALIZE_VALUES,
    RESET_FORM,
    RESET_VALUES,
    SAVE_SEGMENT,
    SAVE_SEGMENT_FAILURE,
    SAVE_SEGMENT_SUCCESS,
    SELECT_SEGMENT,
    SET_CURRENT_VALUES,
    SET_GRID_CONFIG,
    SET_HAS_GROUPS_CONFIG_ERRORS,
    SET_IS_DISABLED_EDITION,
    UPDATE_SEGMENTS,
    UPDATE_SOLAR_MODULES_DESIGN_NUMBER,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    addSegmentModalOpenStatus: false,
    createSegment: { data: {}, errors: null, isSaving: false },
    currentProjectLocation: { data: {} },
    currentValues: {},
    deleteSegment: { errors: null, isDeleting: false },
    enableEdition: { errors: [], isSaving: false },
    fetchParentFieldSegment: {
        data: {
            location: null,
            segments: [],
            solarModulesDesignNumber: 0,
            solarModulesOfferNumber: 0,
        },
        errors: [],
        isFetching: false,
    },
    generateProposal: { errors: [], isFetching: false },
    gridConfig: {},
    hasGroupsConfigErrors: false,
    initialValues: {},
    isDisabledEdition: false,
    offerInfoPatern: { data: {}, errors: [], isFetching: false },
    offerPanels: {
        counters: { assigned: 0, available: 0 },
        data: [],
        errors: [],
        isFetching: true,
    },
    selectedSegment: null,
    updateSegment: { data: {}, errors: null, isSaving: false },
};

const slice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [ADD_SEGMENT_MODAL_OPEN_STATUS]: (state, action) => {
            state.addSegmentModalOpenStatus = action.payload;
        },
        [DELETE_SEGMENT]: (state) => {
            state.deleteSegment.isDeleting = true;
        },
        [DELETE_SEGMENT_FAILURE]: (state, action) => {
            state.deleteSegment = {
                ...state.deleteSegment,
                errors: action.payload,
                isDeleting: false,
            };
        },
        [DELETE_SEGMENT_SUCCESS]: (state) => {
            state.selectedSegment = null;
            state.deleteSegment = {
                ...state.deleteSegment,
                errors: [],
                isDeleting: false,
            };
        },
        [EDIT_SEGMENT]: (state) => {
            state.updateSegment.isSaving = true;
        },
        [EDIT_SEGMENT_FAILURE]: (state, action) => {
            state.updateSegment = {
                ...state.updateSegment,
                errors: action.payload,
                isSaving: false,
            };
        },
        [EDIT_SEGMENT_SUCCESS]: (state, action) => {
            state.updateSegment = {
                ...state.updateSegment,
                data: action.payload,
                errors: [],
                isSaving: false,
            };
        },
        [ENABLED_EDITION]: (state) => {
            state.enableEdition.isSaving = true;
        },
        [ENABLED_EDITION_FAILURE]: (state, action) => {
            state.enableEdition = {
                ...state.enableEdition,
                errors: action.payload,
                isSaving: false,
            };
        },
        [ENABLED_EDITION_SUCCESS]: (state) => {
            state.enableEdition.isSaving = false;
        },
        [FETCH_OFFER_INFO_PATERN]: (state) => {
            state.offerInfoPatern = {
                ...state.offerInfoPatern,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_OFFER_INFO_PATERN_FAILURE]: (state, action) => {
            state.offerInfoPatern = {
                ...state.offerInfoPatern,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_OFFER_INFO_PATERN_SUCCESS]: (state, action) => {
            state.offerInfoPatern = {
                ...state.offerInfoPatern,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_OFFER_PANELS]: (state) => {
            state.offerPanels = {
                ...state.offerPanels,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_OFFER_PANELS_FAILURE]: (state, action) => {
            state.offerPanels = {
                ...state.offerPanels,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_OFFER_PANELS_SUCCESS]: (state, action) => {
            state.offerPanels = {
                ...state.offerPanels,
                counters: action.payload.counters,
                data: action.payload.panels,
                isFetching: false,
            };
        },
        [FETCH_PARENT_FIELD_SEGMENT]: (state) => {
            state.fetchParentFieldSegment = {
                ...state.fetchParentFieldSegment,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_PARENT_FIELD_SEGMENT_FAILURE]: (state, action) => {
            state.fetchParentFieldSegment = {
                ...state.fetchParentFieldSegment,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PARENT_FIELD_SEGMENT_SUCCESS]: (state, action) => {
            state.fetchParentFieldSegment = {
                ...state.fetchParentFieldSegment,
                data: action.payload,
                isFetching: false,
            };
            state.currentProjectLocation.data = action.payload.location;
        },
        [GENERATE_PROPOSAL]: (state) => {
            state.generateProposal.isFetching = true;
        },
        [GENERATE_PROPOSAL_FAILURE]: (state, action) => {
            state.generateProposal = {
                ...state.generateProposal,
                errors: action.payload,
                isFetching: false,
            };
        },
        [GENERATE_PROPOSAL_SUCCESS]: (state) => {
            state.generateProposal.isFetching = false;
        },
        [INITIALIZE_VALUES]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
        },
        [RESET_VALUES]: () => INITIAL_STATE,
        [SAVE_SEGMENT]: (state) => {
            state.createSegment.isSaving = true;
        },
        [SAVE_SEGMENT_FAILURE]: (state, action) => {
            state.createSegment = {
                ...state.createSegment,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_SEGMENT_SUCCESS]: (state, action) => {
            state.createSegment = {
                ...state.createSegment,
                data: action.payload,
                errors: [],
                isSaving: false,
            };
        },
        [SELECT_SEGMENT]: (state, action) => {
            state.selectedSegment = action.payload;
        },
        [UPDATE_SEGMENTS]: (state, action) => {
            state.fetchParentFieldSegment.data.segments = action.payload;
        },
        [UPDATE_SOLAR_MODULES_DESIGN_NUMBER]: (state, action) => {
            state.fetchParentFieldSegment.data = {
                ...state.fetchParentFieldSegment.data,
                solarModulesDesignNumber: action.payload,
            };
        },
        [SET_CURRENT_VALUES]: (state, action) => {
            state.currentValues = action.payload;
        },
        [SET_GRID_CONFIG]: (state, action) => {
            state.gridConfig = action.payload;
        },
        [SET_HAS_GROUPS_CONFIG_ERRORS]: (state, action) => {
            state.hasGroupsConfigErrors = action.payload;
        },
        [SET_IS_DISABLED_EDITION]: (state, action) => {
            state.isDisabledEdition = action.payload;
        },
    },
});

export const actions = slice.actions;

export default slice.reducer;
